// @ts-check
// Card de página e cabeçalho (doc 07, 7.1 e 7.2).
import { html } from 'htm/preact';
import { Icon } from '../../ui/icon.js';
import { LightIconButton } from '../../ui/button.js';
import { useIsMobile } from '../../ui/hooks.js';
import {
  isMobileNavigationOpenState,
  isNavigationDrawerExpandedState,
  toggleNavigationDrawer,
} from '../navigation/navigation-state.js';
import { t } from '../../i18n/index.js';
import { NotificationBell } from '../notifications/notification-bell.js';

/**
 * @param {{ header?: any, children?: any, className?: string }} props
 */
export function PageCard({ header, children, className = '' }) {
  return html`<div class="page-card-wrapper">
    <section class=${`page-card ${className}`}>
      ${header ?? null}
      <div class="page-card-body">${children}</div>
    </section>
  </div>`;
}

/**
 * @param {{ icon?: string | null, title?: any, breadcrumb?: any, actions?: any }} props
 */
export function PageHeader({ icon, title, breadcrumb, actions }) {
  const isMobile = useIsMobile();
  const isCollapsed = !isNavigationDrawerExpandedState.value;
  return html`<header class="page-header">
    <div class="page-header-left">
      ${isMobile
        ? html`<${LightIconButton} icon="IconMenu2" accent="secondary" size="medium" ariaLabel=${t('navigation.openMenu')} onClick=${() => (isMobileNavigationOpenState.value = true)} />`
        : isCollapsed
          ? html`<${LightIconButton} icon="IconLayoutSidebarRightCollapse" accent="secondary" ariaLabel=${t('navigation.expand')} onClick=${toggleNavigationDrawer} />`
          : null}
      ${breadcrumb ?? null}
      ${title !== undefined && title !== null
        ? html`<div class="page-header-title">
            ${icon ? html`<${Icon} name=${icon} size=${16} />` : null}
            <span class="page-header-title-text">${title}</span>
          </div>`
        : null}
    </div>
    <div class="page-header-right">${actions ?? null}<${NotificationBell} /></div>
  </header>`;
}
